import React from "react";
import GameInstructionModal from "../GameInstructionModal";

const BlueRedSearchQuestModal = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Search Quest (Red/Blue)"
      gamePath="/userDashboard/game/red-and-blue-searchquest"
      icon="solar:magnifer-bold"
      instructions={[
        "Wear red and blue glasses.",
        "Locate the target letter (shown at the bottom) inside the grid of random letters.",
        "Click on the matching letter to score points."
      ]}
      isBinocular={true}
    />
  );
};

export default BlueRedSearchQuestModal;
